import TextareaVars from '@/components/_common/TextareaVars';
import React from 'react';

interface Props {
  value?: string;
  onChange?: (content: string) => void;
  disabled?: boolean;
  disabledSelect?: boolean;
  removeOptionalTags?: boolean;
  isNfs?: boolean;
  isAutomaticIbptCalculation?: boolean;
  showApproximateTaxValue?: boolean;
}

const CompanyTextEditor = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ showApproximateTaxValue = false, ...props }, ref) => {
    let tags = [
      {
        description: 'Essa tag será substituida pelo código da OS',
        name: '@{codigoOs}',
      },
      {
        description: 'Essa tag será substituida pela descrição do veículo',
        name: '@{descricaoVeiculo}',
      },
      {
        description: 'Essa tag será substituida pela placa do veículo',
        name: '@{placa}',
      },
      {
        description: 'Essa tag será substituida pelo chassi do veículo',
        name: '@{chassi}',
      },
      {
        description: 'Essa tag será substituida pelo número do sinistro',
        name: '@{sinistro}',
      },
      {
        description: 'Essa tag será substituida pelo km',
        name: '@{km}',
      },
      {
        description: 'Essa tag será substituida pelo km de saída',
        name: '@{kmSaida}',
      },
      {
        description: 'Essa tag será substituida pelo prisma',
        name: '@{prisma}',
      },
      {
        description: 'Essa tag será substituida pela forma de pagamento',
        name: '@{formaDePagamento}',
      },
      {
        description: 'Essa tag será substituida pela frota',
        name: '@{frota}',
      },
    ].filter(
      (tag) => !props.removeOptionalTags || tag.name === '@{formaDePagamento}',
    );

    const extraTagsNfeNfc = [
      {
        description:
          'Essa tag será substituída pelo somatório dos valores de IRPJ dos itens da nota',
        name: '@{totalIR}',
      },
      {
        description:
          'Essa tag será substituída pelo somatório dos valores de CSLL dos itens da nota',
        name: '@{totalCSLL}',
      },
      {
        description:
          'Essa tag será substituída pelo somatório dos valores de PIS dos itens da nota',
        name: '@{totalPIS}',
      },
      {
        description:
          'Essa tag será substituída pelo somatório dos valores de Cofins dos itens da nota',
        name: '@{totalCofins}',
      },
      {
        description:
          'Essa tag será substituída pelas observações da venda direta',
        name: '@{observacaoVD}',
      },
      {
        description:
          'Essa tag será substituída pela alíquota aplicável de cálculo do crédito (Simples Nacional)',
        name: '@{pCredSN}',
      },
      {
        description:
          'Essa tag será substituída pelo valor Total do Crédito de ICMS (Simples Nacional)',
        name: '@{totalCreditValueSN}',
      },
      {
        description:
          'Essa tag poderá ser utilizada para que o próprio sistema insira a mensagem padrão, somente se os valores da alíquota e do crédito forem maiores que 0',
        name: '@{msgPadraoAproveitamentoCreditoIcmsSN}',
      },
      {
        description:
          'Essa tag será substituída pelo valor aproximado dos tributos',
        name: '@{ValorTributosAproximado}',
      },
      {
        description:
          'Essa tag será substituída pelo valor da chave do documento referenciado',
        name: '@{chaveDocReferenciado}',
      },
      {
        description:
          'Essa tag será substituída pelo valor do número do documento referenciado',
        name: '@{numeroDocReferenciado}',
      },
    ].filter((tag) =>
      showApproximateTaxValue ? tag : tag.name !== '@{ValorTributosAproximado}',
    );

    tags = props.isNfs ? tags : [...tags, ...extraTagsNfeNfc];

    const tagsOptions = tags.map((tag) => ({
      value: tag.name,
      label: tag.name,
    }));

    return (
      <>
        <TextareaVars
          {...props}
          tags={tagsOptions}
          style={{ height: 250 }}
          ref={ref}
          selectProps={{
            disabled: props.disabledSelect,
          }}
        />
      </>
    );
  },
);

export default CompanyTextEditor;
